import assets_module from '@assets/provider/store.js'
import materials_module from '@materials/provider/store.js'
import partitions_module from '@partitions/provider/store.js'
import roles_module from '@roles/provider/store.js'
import staffs_module from '@staffs/provider/store.js'
import settings_module from '@settings/store.js'
import stations_module from '@stations/provider/store.js'
import status_prototypes_module from '@status_prototypes/provider/store.js'
import uploader_module from '@uploader/provider/store.js'
import core_waybills_module from '@core_waybills/provider/store.js'
import packer_module from '@packer/store.js'
import operations_module from '@operations/provider/store.js'
import appraisals_module from '@appraisals/provider/store.js'
import user_logs_module from '@user_logs/provider/store.js'
import scanner_module from '@scanner/provider/store.js'
import driver_commission_policies_module from '@driver_commission_policies/provider/store.js'
import driver_commission_reports_module from '@driver_commission_reports/provider/store.js'
import scan_action_prototypes_module from '@scan_action_prototypes/provider/store.js'
import tool_core_waybill_module from '@toolbox/core_waybill/store.js'
import tool_data_card_module from '@toolbox/data_card/store.js'
import provider_node_module from '@provider_node/provider/store.js'
import distributions_module from '@components/distributions/provider/store.js'
import driver_commissions_module from '@components/driver_commissions/provider/store.js'
import customers_module from '@components/customers/provider/store.js'
import personal_monitor_module from '@components/monitor/personal/store.js'
import global_monitor_module from '@components/monitor/global/store.js'

window.config = require('@config/config.js')
const CONFIG = new config()

const store = {
    namespaced: true,
    state: {
        /**
         * ========================================================================
         * Current staff
         * ========================================================================
        **/
        current_staff: {},
        current_staff_operation: {},
        current_staff_operations: [],

        /**
         * ========================================================================
         * Page permission
         * is_enable_permission_validation 為 true 才會啟用頁面驗證功能
         * ========================================================================
        **/

        /**
         * ========================================================================
         * Routes
         * ========================================================================
        **/
        routes: {},

        /**
         * ========================================================================
         * Theme & Config
         * ========================================================================
        **/
        is_can_use_scanner: false,
        service_config: {},
        theme_menu: [],
        theme_menu_keys: [],

        /**
         * ========================================================================
         * Position
         * ========================================================================
        **/
        is_auto_gps_station_position_by_60s: false,
        is_auto_gps_station_position_once: false,
        current_position: {
            is_first_initialized: false,
            status: "",
            messages: "",
            latitude: "",
            longitude: "",
            address: {
                country: "", //國
                locality: "", // 縣市
                political: "", // 行政區
                full: ""
            },
        },

        /**
         * ========================================================================
         * Others
         * ========================================================================
        **/
        papers_label_infos: [],
        notifications: [],
        operations: [],
        stations: [],
        node: {},

    },
    getters: {
        current_station(state, getters, rootState, rootGetters) {
            return _.findLast(state.stations, (station) => {
                return station.identity == state.current_staff.station_identity
            }) || {
                identity: null,
                name: null,
            }
        },
        is_current_staff_need_station(state, getters, rootState, rootGetters) {
            if (
                !getters.current_station.identity &&
                state.current_staff.theme_name != "manager"
            ) {
                return true
            }
            return false
        },
        is_current_staff_minimalist_layout(state, getters, rootState, rootGetters) {
            // 2017-12-14 暫時無視 staff theme 切換 grid

            return (state.current_staff.theme_name == "driver")
                ? false
                : true
        },
    },
    actions: {
        fetch_node(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_me).parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_node', response.data.node)
                })
                .catch(error => {
                    console.log('Failed to fetch node.')
                })
        },
        fetch_routes(context, payload) {
            var url = new RestUrl(context.rootState.settings.station.get_routes_url).parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    var routes = response.data.routes
                    _.forEach(routes, (route, key) => {
                        routes[key] = CONFIG.lms_url + route
                    })

                    context.commit('set_routes', routes)
                })
                .catch(error => {
                    console.log('Failed to fetch routes.')
                })
        },
        fetch_routes(context, payload) {
            var url = new RestUrl(context.rootState.settings.provider.get_routes_url).parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    var routes = response.data.routes
                    _.forEach(routes, (route, key) => {
                        routes[key] = CONFIG.lms_url + route
                    })

                    context.commit('set_routes', routes)
                })
                .catch(error => {
                    console.log('Failed to fetch routes.')
                })
        },
        fetch_current_staff(context, payload) {
            var url =  new RestUrl(context.rootState.provider.routes.api_v1_provider_staffs_current_staff).parse(
                {},
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
            .then(response => {
                context.commit('set_current_staff', response.data.staff)
            })
            .catch(error => {
                console.log('Failed to fetch current staff.')
            })
        },
        fetch_current_staff_operations(context, payload) {
            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_operations)
            var url = rest_url.parse(
                {},
                '?is_done=false&is_canceled=false&staff_identity='+context.state.current_staff.identity
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
            .then(response => {
                if (response.data.status == "success") {
                    context.commit('set_current_staff_operations', response.data.operations)
                }
            })
            .catch(error => {
                console.log('Failed to fetch current staff operation.')
            })
        },
        fetch_stations(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_stations).parse(
                {},
                "?pagination=false"
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
            .then(response => {
                context.commit('set_stations', response.data.stations)
            })
            .catch(error => {
                console.log('Failed to fetch stations.')
            })
        },
        fetch_customers(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_customers).parse(
                {},
                "?" + object_to_query({
                    pagination: false,
                })
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_customers', response.data.customers)
                })
                .catch(error => {
                    console.log('Failed to fetch customers.')
                })
        },
        fetch_notifications(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_notifications).parse()

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_notifications', response.data.notifications)
                })
                .catch(error => {
                    console.log('Failed to fetch notifications.')
                })
        },
        fetch_papers_label_infos(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_papers_label_infos).parse()

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    console.log(response.data);
                    context.commit('set_papers_label_infos', response.data.label_infos)
                })
                .catch(error => {
                    console.log('Failed to fetch papers label infos.')
                })
        },
        fetch_current_position_address(context, payload) {
            var API_KEY = 'AIzaSyBB-BKWJ_pcsE0zCmdeYkJfB5KcMaQyB14'
            var latlng = context.state.current_position.latitude+','+context.state.current_position.longitude
            var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+latlng+'&key='+API_KEY

            return axios.get(url)
                .then(response => {
                    console.log('Goolge Geocoding API response', response.data)
                    if (response.data.status == "OK") {
                        context.dispatch("set_current_position_address", _.head(response.data.results))
                    } else {
                        console.log('Failed to fetch address for Goolge Geocoding API, because:', response.data.status)
                    }
                })
                .catch(error => {
                    console.log('Failed to fetch address for Goolge Geocoding API.')
                })
        },
        update_current_staff_station_identity(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_staff_update).parse({
                "identity": context.state.current_staff.identity,
            })

            return axios.post(
                url,
                {station_identity: payload.identity},
                {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_current_staff_station', payload)
                })
                .catch(error => {
                    console.log('Failed to update current_staff_station_identity.')
                })
        },
        set_current_staff_operation(context, payload) {
            context.commit('set_current_staff_operation', payload)

            localStorage.setItem(
                "current_staff_operations_number",
                payload.number ? payload.number : ""
            )
        },
        set_current_position(context, payload) {
            _.forEach(payload, (value, key) => {
                context.state.current_position[key] = value
            })
        },
        set_current_position_address(context, payload) {
            // payload == google maps api results first, Line 300
            context.state.current_position.address.full = payload.formatted_address
            try {
                var settings = [{
                    name: "country", //國
                    types: ["country", "political"]
                },{
                    name: "locality", // 縣市
                    types: ["administrative_area_level_1", "political"],
                    types2: ["administrative_area_level_2", "political"],
                },{
                    name: "political", // 區
                    types: ["administrative_area_level_3", "political"],
                    types2: ["locality", "political"],
                }]

                _.forEach(settings, (setting) => {
                    var reslut = _.findLast(payload.address_components, (address_component) => {
                        if (!_.difference(address_component.types, setting.types).length) {
                            return true
                        } else {
                            if (setting.types2) {
                                if (!_.difference(address_component.types, setting.types2).length) {
                                    return true
                                }
                            }
                            return false
                        }
                    }) || {}
                    context.state.current_position.address[setting.name] = reslut.long_name || ""
                })
            } catch (e) {
                console.log(e)
            }
            console.log("google maps api解析地址為: ",context.state.current_position.address)
        },
    },
    mutations: {
        set_routes(state, payload) {
            state.routes = payload
        },
        set_current_staff(state, payload) {
            state.current_staff = payload
        },
        set_current_staff_operation(state, payload) {
            state.current_staff_operation = payload
        },
        set_current_staff_operations(state, payload) {
            state.current_staff_operations = payload
        },
        set_current_staff_station(state, payload) {
            state.current_staff.station_identity = payload.identity
            state.current_staff.station = payload
        },
        set_node(state, payload) {
            state.node = payload
        },
        set_routes(state, payload) {
            state.routes = payload
        },
        set_stations(state, payload) {
            state.stations = payload
        },
        set_customers(state, payload) {
            state.customers = payload
        },
        set_notifications(state, payload) {
            state.notifications = payload
        },
        set_papers_label_infos(state, payload) {
            state.papers_label_infos = payload
        },
        update_notification(state, payload) {
            var index = _.findIndex(state.notifications, notification => notification.identity == payload.identity)
            state.notifications.splice(index, 1, payload)
        },
        add_notification(state, payload) {
            state.notifications.unshift(payload)
        },
    },
    modules: {
        assets_module,
        materials_module,
        scanner_module,
        partitions_module,
        roles_module,
        staffs_module,
        settings_module,
        stations_module,
        status_prototypes_module,
        uploader_module,
        core_waybills_module,
        packer_module,
        operations_module,
        appraisals_module,
        user_logs_module,
        driver_commission_policies_module,
        driver_commission_reports_module,
        scan_action_prototypes_module,
        tool_core_waybill_module,
        tool_data_card_module,
        provider_node_module,
        distributions_module,
        driver_commissions_module,
        customers_module,
        personal_monitor_module,
        global_monitor_module,
    }
}

export default store
